module.exports = __webpack_public_path__ + "media/images/user-64d31e75071058514170d9121e295b93.png";